import React, { useState, useEffect } from 'react'
import { alertError, alertInfo, alertSuccess } from '../../../../utils/Alert'
import { useHistory } from 'react-router-dom'

import IuPassword from '../../../../Components/InputPassword'

import api from '../../../../services/api'
import { login } from '../../../../services/auth'

export default function Register() {
  const history = useHistory()
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [photo, setPhoto] = useState(0)

  useEffect(() => {
    setPhoto(Math.floor(Math.random() * (3 - 1) + 1))
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      if (
        name === '' ||
        email === '' ||
        password === '' ||
        confirmPassword === ''
      ) {
        alertInfo('Por favor preencha todos os campos!')
        return
      }

      if (password.length < 6) {
        alertInfo('Por favor, insira uma senha maior que 6 dígitos')
        return
      }

      if (password !== confirmPassword) {
        alertInfo('A confirmação de senha não está correta')
        return
      }

      const usuario = email.indexOf('@')
      const dominio = email.indexOf('@') + 1

      var pattern = new RegExp(
        /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
      )
      if (!pattern.test(email)) {
        alertInfo('Informe um e-mail valido!')
        return
      }

      const response = await api.post('/user/register', {
        name,
        email,
        password,
      })

      login(response.data.token, response.data.user, '1')

      history.push('/home')

      setName('')
      setEmail('')
      setPassword('')
      setConfirmPassword('')
    } catch (response) {
      alertError(response.data.error)
    }
  }

  return (
    <div className="form-body">
      <div className="auth-logo">
        <img
          className="logo-manual"
          src="../assets/images/logo-dark.png"
          alt=""
        />
        <h1>
          Construindo em conjunto com <strong>você</strong> os melhores{' '}
          <strong>resultados!</strong>
        </h1>
        <a href="">
          <div className="logo">
            {photo == 1 ? (
              <img
                className="logo-size"
                src="../assets/images/creator-amico.svg"
                alt=""
              />
            ) : (
              photo == 2 && (
                <img
                  className="logo-size"
                  src="../assets/images/instruction-manual.jpg"
                  alt=""
                />
              )
            )}
          </div>
        </a>
      </div>
      <div className="row">
        <div className="img-holder">
          <div className="bg"></div>
          <div className="info-holder"></div>
        </div>
        <div className="form-holder">
          <div className="form-content">
            <div className="form-items">
              <h3>
                Através da BV3 você tem acesso ao suporte e a assistência certa!
              </h3>
              <p>
                A BV3 manuais te fornece de forma prática o manual ideal para o
                seu imóvel!
              </p>
              <div className="page-links">
                <a onClick={() => history.push('/login')}>Login</a>
                <a className="active">Cadastro</a>
              </div>
              <form>
                <input
                  className="form-control"
                  type="text"
                  name="name"
                  placeholder="Nome:"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
                <input
                  className="form-control"
                  type="email"
                  name="email"
                  placeholder="E-mail:"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <IuPassword
                  value={password}
                  setValue={setPassword}
                  placeHolder="Senha:"
                />
                <IuPassword
                  value={confirmPassword}
                  setValue={setConfirmPassword}
                  placeHolder="Confirmar Senha:"
                />
                <div className="form-button">
                  <button className="ibtn" onClick={(e) => handleSubmit(e)}>
                    Cadastre-se
                  </button>
                </div>
              </form>
              <a href="">
                <div className="website-logo logo">
                  <p>by:</p>
                  <img
                    className="logo-size"
                    src="../assets/images/logo2-white.png"
                    alt=""
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
